<template>
  <div class="row">
    <div class="col-lg-12 mb-4">
      <div class="text-center m-t-lg">
        <h3>Frotix Testar</h3>
      </div>
    </div>

    <SyncAlerts
      v-if="user.usertype === 1 && dashboard.syncServices && dashboard.syncServices.length"
      :syncServices="dashboard.syncServices"
      @toDetails="toDetails"
    >

    </SyncAlerts>

    <StockAlerts
      v-if="user.usertype === 1 && dashboard.alerts && dashboard.alerts.length"
      :alerts="dashboard.alerts"
      @suspend="confirmSuspendEmail"
    />

    <b-modal
      title="Suspender envio de e-mail"
      @hidden="onCloseModalSuspendEmail"
      v-model="showModalSuspendEmail"
    >
      <div
        class="form-group"
        :class="{ 'has-error': errors.has('suspend_until') }"
      >
        <label for="suspend_until">{{ $t("suspend_until") }}</label>
        <input
          type="date"
          id="suspend_until"
          name="suspend_until"
          class="form-control"
          v-model="dateSuspend"
          v-validate="'required'"
        />
        <small
          v-show="errors.has('suspend_until')"
          class="form-text text-muted"
        >
          {{ errors.first("suspend_until") }}
        </small>
      </div>

      <template #modal-footer>
        <button
          type="button"
          class="btn btn-secondary"
          @click="showModalSuspendEmail = false"
        >
          {{ $t("close") }}
        </button>

        <button type="button" class="btn btn-danger" @click="suspendEmail">
          {{ $t("suspend") }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import StockAlerts from "@/components/shared/StockAlerts.vue";
import CardTitleContent from "@/components/shared/CardTitleContent.vue";
import SyncAlerts from "@/components/shared/SyncAlerts.vue";

export default {
  name: "Home",

  components: {
    StockAlerts,
    CardTitleContent,
    SyncAlerts
  },

  data() {
    return {
      alertIdTemp: undefined,
      dateSuspend: "",
      showModalSuspendEmail: false,
    };
  },

  computed: {
    ...mapState({
      dashboard: (state) => state.dashboard.all,
      user: (state) => state.session.user,
    }),
  },

  methods: {
    confirmSuspendEmail(id) {
      this.alertIdTemp = id;

      this.showModalSuspendEmail = true;
    },

    onCloseModalSuspendEmail() {
      this.alertIdTemp = undefined;
      this.dateSuspend = "";
    },

    async suspendEmail() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) {
        return new Error(this.$t("invalid_form_fields"));
      }

      this.showModalSuspendEmail = false;

      const { dispatch } = this.$store;

      const suspended = await dispatch("stockalerts/suspendEmail", {
        id: this.alertIdTemp,
        date: this.dateSuspend,
      });

      if (suspended) {
        await dispatch("dashboard/fetchAll");
      }
    },

    toDetails() {
      this.$router.push({ name: "listsyncservice" });
    },
  },

  async mounted() {
    if (this.user.usertype === 2) {
      return this.$router.push({ name: "listschedules" });
    }

    await this.$store.dispatch("dashboard/fetchAll");
  },
};
</script>
